
const baseUrl = 'https://e-commarce-mern.onrender.com';

export { baseUrl };
